import { createContext } from "react";
import { useState, useEffect } from "react";
import { countries as baseCountries } from "../data/mockData";
import { removeDuplicateCountries } from "../utils/global";
import { useParams } from "react-router-dom";

export const BulkContext = createContext();
export const countryGroups = [
    { label: "World", id: "001", code: "5000" },
    { label: "Western Asia", id: "145", code: "5305" },
    { label: "Asia", id: "142", code: "5300" },
    { label: "Americas", id: "019", code: "5200" },
    { label: "Latin America and the Caribbean", id: "419", code: "5205" },
    { label: "Caribbean", id: "029", code: "5206" },
    { label: "Southern Asia", id: "034", code: "5303" },
    { label: "Africa", id: "002", code: "5100" },
    { label: "Middle Africa", id: "017", code: "5102" },
    { label: "Northern Europe", id: "154", code: "5402" },
    { label: "Europe", id: "150", code: "5400" },
    { label: "Southern Europe", id: "039", code: "5403" },
    { label: "South America", id: "005", code: "5207" },
    { label: "Oceania", id: "009", code: "5500" },
    { label: "Polynesia", id: "061", code: "5504" },
    { label: "Eastern Africa", id: "014", code: "5101" },
    { label: "Australia and New Zealand", id: "053", code: "5501" },
    { label: "Western Europe", id: "155", code: "5404" },
    { label: "Western Africa", id: "011", code: "5105" },
    { label: "Eastern Europe", id: "151", code: "5401" },
    { label: "Central America", id: "013", code: "5204" },
    { label: "Northern America", id: "021", code: "5203" },
    { label: "South-eastern Asia", id: "035", code: "5304" },
    { label: "Southern Africa", id: "018", code: "5104" },
    { label: "Eastern Asia", id: "030", code: "5302" },
    { label: "Northern Africa", id: "015", code: "5103" },
    { label: "Micronesia", id: "057", code: "5503" },
    { label: "Melanesia", id: "054", code: "5502" },
    { label: "Central Asia", id: "143", code: "5301" },
];

const countries = removeDuplicateCountries([...baseCountries, ...countryGroups]);


export const BulkProvider = ({ children }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [comparingCountries, setComparingCountries] = useState([]);
    const [checked, setChecked] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [apiUrls, setApiUrls] = useState([]);
    const { countryId } = useParams();



    useEffect(() => {
        const selectedCountry = countries.find((country) => country.id === countryId);

        if (selectedCountry) {
            const isAlreadyPresent = comparingCountries?.some(
                (country) => country.id === selectedCountry.id
            );

            if (!isAlreadyPresent) {
                setComparingCountries((prevCountries) =>
                    removeDuplicateCountries([...prevCountries, selectedCountry])
                );
            }
        }
    }, [countryId]);



    return (
        <BulkContext.Provider
            value={{
                searchQuery,
                countries,
                setSearchQuery,
                comparingCountries,
                setComparingCountries,
                checked,
                setChecked,
                selectedItems,
                setSelectedItems,
                apiUrls,
                setApiUrls
            }}
        >
            {children}
        </BulkContext.Provider>
    );
};
